import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Dropdown from "react-bootstrap/Dropdown";
import Pagination from "react-bootstrap/Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  createClient,
  getBots,
  getClients,
  getFeedback,
  updateClient,
} from "../Redux/Actions/auth";
import { toast } from "react-toastify";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import NoData from "../Components/NoData";
import {
  capitalize,
  dateOfBookingEventWise,
  downloadCSV,
  formattedDate,
  truncateString,
} from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import SearchComponent from "../Components/CommanSearch";
import DeleteModal from "../Components/DeleteModal";
import AdminActions from "../Redux/Actions/AdminActions";

export default function Feedback() {
  const feedbackList = useSelector((e) => e.userAuth.feedbackList);
  const botList = useSelector((e) => e.userAuth.botList)

  const ImageUrl = process.env.REACT_APP_IMG_URL;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const totalEntries = feedbackList?.pagination?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filterBot, setFilterBot] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentBotId, setCurrentBotId] = useState("");

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handlePageChange = (page) => {
    setCurrentPage(page + 1);
    navigate(`/feedback?page=${page + 1}`);
  };

  const handleChange = async (id) => {
    setCurrentBotId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteUser = () => {
    dispatch(AdminActions.deleteBot({ chatbotId: currentBotId })).then(
      (res) => {
        if (res?.payload?.status == 200) {
          toast.success(res?.payload?.message);
          Inialize();
        } else {
          toast.error(res?.payload?.message);
        }
        handleCloseDeleteModal();
      }
    );
  };

  const Inialize = () => {
    try {
      const params = new URLSearchParams(location.search);
      const page = params.get("page") || currentPage;
      setCurrentPage(page);
      const searchQuery = params.get("search") || "";
      const queryParams = searchQuery
        ? { name: searchQuery }
        : { page: page, limit };
      if (filterBot) {
        queryParams['chatbot'] = filterBot
      }
      dispatch(startstopLoading(true));
      dispatch(getFeedback(queryParams)).then((res) => {
        dispatch(startstopLoading(false));
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const Inialize = () => {
      try {
        dispatch(getBots({ page: 1, limit: 20 })).then((res) => {
        });
      } catch (error) {
        console.log(error);
      }
    }
    Inialize()
  }, [])

  useEffect(() => {
    Inialize();
  }, [location.search, dispatch, currentPage, location.pathname, limit, filterBot]);

  return (
    <Layout>
      <Container fluid>
        <div className="filters">
          <div className="inner-filter-field">
            <div className="image-heading-text">
              <h2>Feedback</h2>
            </div>
            <div className="user-search">
              <div className="drop-down">
                <div className="select-box">
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) => setLimit(e.target.value)}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
              <div className="search-tab">
                <div className="input-search">
                  <SearchComponent heading="Bot" />
                </div>
                <div className="select-box-right">
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) => setFilterBot(e.target.value)}
                  >
                    <option value={''} selected disabled>Select Chatbots</option>
                    {botList?.chatbots?.map((res, index) =>
                      <option key={res.chatbotId} value={res.chatbotId}>{res.name + `  (${res.chatbotId})`}</option>
                    )}

                  </Form.Select>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <Table size="sm" className="table-cmn">
                <thead>
                  <tr>
                    <th>Chat ID</th>
                    <th>Name</th>
                    <th>Thumbs up</th>
                    <th>Thumbs down</th>
                  </tr>
                </thead>
                <tbody>
                  {feedbackList?.adminList?.map((res, index) =>
                    <tr key={index}>
                      <td>
                        <div className="first-user">
                          <div className="user-id">
                            <p>{res.chatbotId}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="first-user">
                          <div className="user-id">
                            <p>{res.name}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="user-role">
                          <p>{res.thumbsUpBy.length}</p>
                        </div>
                      </td>
                      <td>
                        <div className="user-role">
                          <p>{res.thumbsDownBy.length}</p>
                        </div>
                      </td>
                    </tr>
                  )}

                </tbody>
              </Table>
              {feedbackList?.pagination?.total > 1 && (
                <PaginationComponent
                  currentPage={currentPage - 1}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  totalEntries={totalEntries}
                  entriesPerPage={entriesPerPage}
                />
              )}
            </div>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              {" "}
              © {new Date().getFullYear()}, Made with ❤️ by <span>Codobux</span>
            </p>
          </div>
        </div>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={handleDeleteUser}
        name={"bot"}
      />
    </Layout>
  );
}
